import { Component, OnInit, HostListener } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

@Component({
  selector: 'app-animation-comedy',
  templateUrl: './animation-comedy.component.html',
  styleUrls: ['./animation-comedy.component.scss']
})
export class AnimationComedyComponent implements OnInit {
  windowsWidth;
  facebookUrl = '';
  buttonShare = false;

  constructor() { }

  ngOnInit() {
    this.windowsWidth = window.innerWidth;
    this.goBackToTop();
    this.facebookUrl = window.location.href;
  }

  gotoTop() {
    document.getElementById('parentWrap').scrollTo({ 'top': 0, behavior: 'smooth' });
  }

  goBackToTop() {
    document.getElementsByTagName('body')[0].scroll({
      top: 0,
      behavior: 'smooth'
    });
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.windowsWidth = window.innerWidth;
  }
  shareButton() {
    this.buttonShare = !this.buttonShare;
    if (this.buttonShare === true) {
      document.getElementById('sharePopup').style.display = 'flex';
    } else {
      document.getElementById('sharePopup').style.display = 'none';
    }
  }
}
